
import { defineComponent, reactive } from 'vue'

import TheButton from '@/common/components/UI/TheButton/index.vue'
import FileReader from '@/common/components/UI/FileReader/index.vue'
import PageTitle from '@/common/components/UI/PageTitle/index.vue'

import { required } from '@vuelidate/validators'
import useVuelidate from '@vuelidate/core'

import useNotifications from '@/common/composable/useNotifications'
import { onec } from '@/core/realisations/onec.realisation'

export default defineComponent({
    components: {
        TheButton,
        FileReader,
        PageTitle,
    },
    setup() {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            file: [] as File[],
        })

        const state_form$ = useVuelidate(
            {
                file: { required },
            },
            state
        )

        const reset = () => {
            state.file = []
            state_form$.value.$reset()
        }

        const submit = async () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            try {
                state.is_loading = true

                const form_data = new FormData()
                form_data.append('file', state.file[0])

                await onec.syncOnec(form_data)

                notifications.notify({
                    title: 'Статусы успешно синхронизировались',
                    type: 'success',
                })

                reset()
            } catch (error) {
                console.error(error)

                notifications.notifyError({
                    error,
                    title: 'Произошла ошибка',
                })
            } finally {
                state.is_loading = false
            }
        }

        return {
            state,
            state_form$,
            reset,
            submit,
        }
    },
})
